import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "prizeText" }
const _hoisted_3 = {
  class: "prizeAmount",
  style: {"color":"#ffd49f"}
}
const _hoisted_4 = { class: "prizeText" }
const _hoisted_5 = { class: "prizeAmount" }

import { getFirstAndLastAmount, getPeoplePerDay, MisteryBoxConfigData } from '@/view/misteryBox/supportScript';
import CustomHeader from '../components/common/customHeader.vue';
import GiftCard from './components/giftCard.vue';
import { computed, PropType, ref } from 'vue';
import { formatCurrency } from '@/utils/commonFunction';
import NoData from '../components/common/noData.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'misteryBoxView',
  props: {
    dataSet: {
        type: Object as PropType<MisteryBoxConfigData>,
        required: true
    }
},
  emits: ['updateInfo'],
  setup(__props, { emit: __emit }) {

const emits = __emit
const props = __props
const depositButtonConfig = computed<any>(() => props.dataSet.depositButtonConfig)
const mysteryRewardButtonConfig = computed<any>(() => props.dataSet.mysteryRewardButtonConfig)
const nonDepositButtonConfig = computed<any>(() => props.dataSet.nonDepositButtonConfig)
const todayDepositButtonConfig = computed<any>(() => props.dataSet.todayDepositButtonConfig)
const totalClaimedAmount = computed<number>(() => props.dataSet.totalClaimedAmount)
const totalPrizeAmount = computed<number | string>(() => props.dataSet.totalPrizeAmount)
const isEmptyList = computed<boolean>(() => props.dataSet.isEmptyList)
const updateInfoData = () => {
    emits('updateInfo')
}

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('misteryBox.supriseRewards')
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_row, { class: "topCard" }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, {
            span: "12",
            class: "columnContainer"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_van_icon, {
                  name: "point-gift",
                  size: "20px",
                  color: "#ffedcbbf"
                })
              ]),
              _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('misteryBox.totalPrize')), 1),
              _createElementVNode("div", _hoisted_3, _toDisplayString('R$ ' + _unref(formatCurrency)(totalPrizeAmount.value)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "12",
            class: "columnContainer"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_van_icon, {
                  name: "balance-list",
                  size: "20px",
                  color: "#ffedcbbf"
                })
              ]),
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('misteryBox.alreadyClaimed')), 1),
              _createElementVNode("div", _hoisted_5, _toDisplayString('R$ ' + _unref(formatCurrency)(totalClaimedAmount.value)), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (nonDepositButtonConfig.value && (nonDepositButtonConfig.value?.available || nonDepositButtonConfig.value?.alreadyClaimed))
        ? (_openBlock(), _createBlock(GiftCard, {
            key: 0,
            onUpdateInfo: updateInfoData,
            rewardType: 1,
            "already-claimed": nonDepositButtonConfig.value?.alreadyClaimed,
            title: _ctx.$t('misteryBox.nonrechargeUsers'),
            "bottom-text": _ctx.$t('misteryBox.dailyPrize') + _unref(getFirstAndLastAmount)(nonDepositButtonConfig.value?.mysteryBoxLevel?.config)
          }, null, 8, ["already-claimed", "title", "bottom-text"]))
        : _createCommentVNode("", true),
      (depositButtonConfig.value && (depositButtonConfig.value?.available || depositButtonConfig.value?.alreadyClaimed))
        ? (_openBlock(), _createBlock(GiftCard, {
            key: 1,
            onUpdateInfo: updateInfoData,
            rewardType: 2,
            "already-claimed": depositButtonConfig.value?.alreadyClaimed,
            title: _ctx.$t('misteryBox.rechargeUsers'),
            "bottom-text": _ctx.$t('misteryBox.dailyPrize') + _unref(getFirstAndLastAmount)(depositButtonConfig.value?.mysteryBoxLevel?.config)
          }, null, 8, ["already-claimed", "title", "bottom-text"]))
        : _createCommentVNode("", true),
      (todayDepositButtonConfig.value && (todayDepositButtonConfig.value?.available || todayDepositButtonConfig.value?.alreadyClaimed))
        ? (_openBlock(), _createBlock(GiftCard, {
            key: 2,
            onUpdateInfo: updateInfoData,
            rewardType: 3,
            "already-claimed": todayDepositButtonConfig.value?.alreadyClaimed,
            title: _ctx.$t('misteryBox.rechargeUsersToday'),
            "bottom-text": _ctx.$t('misteryBox.limitedPeopleText', { value: _unref(getPeoplePerDay)(todayDepositButtonConfig.value) })
          }, null, 8, ["already-claimed", "title", "bottom-text"]))
        : _createCommentVNode("", true),
      (mysteryRewardButtonConfig.value && (mysteryRewardButtonConfig.value?.available || mysteryRewardButtonConfig.value?.alreadyClaimed))
        ? (_openBlock(), _createBlock(GiftCard, {
            key: 3,
            onUpdateInfo: updateInfoData,
            rewardType: 4,
            "already-claimed": mysteryRewardButtonConfig.value?.alreadyClaimed,
            title: _ctx.$t('misteryBox.randomLuckyPrize'),
            "bottom-text": _ctx.$t('misteryBox.prize') + _unref(getFirstAndLastAmount)(mysteryRewardButtonConfig.value?.mysteryBoxLevel?.config)
          }, null, 8, ["already-claimed", "title", "bottom-text"]))
        : _createCommentVNode("", true),
      (isEmptyList.value)
        ? (_openBlock(), _createBlock(NoData, { key: 4 }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})